const alphalinkDataRecharge = {
  index: {
  },
  tab: {
    main: "Recharge",
  },
  new: {
    title: "Nouvelle recharge mobile Alphalink"
  },
  search: {}
};

export default alphalinkDataRecharge;
